import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import AppScreenshots from './components/AppScreenshots';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import WaitlistSection from './components/WaitlistSection';
import Footer from './components/Footer';
import { initGA, trackPageView } from './utils/analytics';
import { useAnalytics } from './hooks/useAnalytics';

function App() {
  // Initialize analytics
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname);
  }, []);

  // Track user engagement
  useAnalytics();

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <AppScreenshots />
        <Features />
        <HowItWorks />
        <Pricing />
        <FAQ />
        <Contact />
        <WaitlistSection />
      </main>
      <Footer />
    </div>
  );
}

export default App; 